"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessType = void 0;
/* eslint-disable no-shadow */
var AccessType;
(function (AccessType) {
    AccessType["OBJECT_READ"] = "ObjectRead";
    AccessType["OBJECT_WRITE"] = "ObjectWrite";
    AccessType["OBJECT_READ_WRITE"] = "ObjectReadWrite";
    AccessType["ANY_OBJECT_READ"] = "AnyObjectRead";
    AccessType["ANY_OBJECT_WRITE"] = "AnyObjectWrite";
    AccessType["ANY_OBJECT_READ_WRITE"] = "AnyObjectReadWrite";
})(AccessType = exports.AccessType || (exports.AccessType = {}));
